<div #mini
    class="btn-box"
    [ngClass]="btn?.color || ''"
    [class.disabled]="btn?.disabled"
    (click)="callBtnEvent($event)">
    <i *ngIf="btn?.icon" [ngClass]="btn?.icon || ''"></i>
</div>
